import { dataFormatters } from "./dataFormatters";
import { getDate } from "./dateParser";

export const DateUtils = {
  getTimeDiffInMilliseconds: (startDate, startTime, endDate, endTime) => {
    const totalTime = "";
    const startDateTime = getDate(new Date(`${startDate} ${startTime}`));
    const endDateTime = getDate(new Date(`${endDate} ${endTime}`));
    if (!startDateTime || !endDateTime) {
      return null;
    }

    return endDateTime.getTime() - startDateTime.getTime();
  },
};



// WEBPACK FOOTER //
// ./src/utils/dateUtils.js